// ------------------------------------------------------------------------- //
// Do not modify this file. SignalR services and events are managed by store //
// ------------------------------------------------------------------------- //
import { type App } from 'vue'
import * as signalR from '@microsoft/signalr';
import store from '@/generated/stores/index';
import HubServices from '@/generated/hub/HubServices';


export default {
    install(app: App): void {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${app.config.globalProperties.$http.defaults.baseURL}/ci-hub`, {
                accessTokenFactory: () => store.getters.httpToken
            })
            .configureLogging(signalR.LogLevel.Information)
            .build()

        store.dispatch('setHubCx', connection)

        function start() {
            if (store.getters.sessionValid) {
                if (!store.getters.modeLocal) {
                    connection.start()
                        .then(() => {
                          store.dispatch('setHubReady', true);
                          store.dispatch('resynch');
                          HubServices.setConnection(connection, true);
                        })
                        .catch(() => {
                            setTimeout(() => start(), 5000)
                        })
                }
            } else {
                setTimeout(() => start(), 100)
            }
        }

        connection.onclose(() => {
            store.dispatch('setHubReady', false)
            HubServices.setConnection(connection, false);
            start()
        })

        start()
    }
}
